import { useEffect, useState } from 'react'
import { api } from '../api.js'

// Le guide de démarrage. Ses étapes ne se cochent pas à la main : elles se
// lisent dans la configuration réelle, ce qui évite un guide qui affirme que
// tout va bien alors que rien n'est réglé.
export default function MiseEnRoute({ onAller, droits = [] }) {
  const [data, setData] = useState(null)
  const [replie, setReplie] = useState(false)

  useEffect(() => { api.miseEnRoute().then(setData).catch(() => setData(null)) }, [])
  // Un agent instructeur n'a rien à configurer : le guide ne s'adresse qu'à
  // ceux qui peuvent réellement agir dessus.
  if (!data?.afficher || !droits.includes('config.modifier')) return null

  const total = data.etapes.length
  const faites = total - data.reste

  return (
    <section className="mise-en-route">
      <header>
        <div>
          <h2>Mettre votre portail en route</h2>
          <p className="aide">{faites} sur {total}. Vous pouvez vous arrêter et reprendre
            plus tard, rien n'est visible des habitants avant la mise en ligne.</p>
        </div>
        <div className="pousse" />
        <div className="jauge-etapes" aria-hidden="true">
          {data.etapes.map((e) => <i key={e.cle} className={e.fait ? 'fait' : ''} />)}
        </div>
        <button className="lien-mini" onClick={() => setReplie(!replie)}>
          {replie ? 'Voir les étapes' : 'Replier'}
        </button>
      </header>

      {!replie && (
        <ol>
          {data.etapes.map((e) => (
            <li key={e.cle} className={e.fait ? 'fait' : ''}>
              <span className="marque" aria-hidden="true">{e.fait ? '✓' : ''}</span>
              <div>
                <strong>{e.titre}</strong>
                <span>{e.detail}</span>
              </div>
              {e.chiffre && <span className="chiffre">{e.chiffre}</span>}
              <button className={`btn sm ${e.fait ? '' : 'pri'}`} onClick={() => onAller(e.vers)}>
                {e.fait ? 'Revoir' : 'Y aller'}
              </button>
            </li>
          ))}
        </ol>
      )}
    </section>
  )
}
